import React from "react"
import { Control } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
    EPayFacType,
    FormGroupWithCheckbox,
    getMerchantPreOnboardingSwiipeServices,
    IFormBase,
    IMerchantOnboardingServicesSubForm,
    isServiceAvailableForMerchantCountry,
    LayoutSeparator,
    StandardParagraph,
} from "swiipe.portal.shared"
import { getMerchantPreOnboardingServicesConfig } from "../../services/merchantPreOnboardingService"
import "./MerchantOnboardingServicesForm.scss"

interface IMerchantOnboardingServicesFormProps<TForm extends IFormBase> {
    defaultPayFaq: EPayFacType
    merchantCountryCode: string
    control: Control<TForm>
    getFieldsFromControl: (form: TForm | undefined) => IMerchantOnboardingServicesSubForm | undefined
    fieldSelectorPrefix: string
}

export const MerchantOnboardingServicesForm = <TForm extends IFormBase>({
    defaultPayFaq,
    merchantCountryCode,
    control,
    getFieldsFromControl,
    fieldSelectorPrefix,
}: IMerchantOnboardingServicesFormProps<TForm>) => {
    const { t } = useTranslation()
    const getFieldSelector = (fieldName: string) => fieldSelectorPrefix + fieldName

    const values = getFieldsFromControl(control.getValues() as TForm)

    const servicesConfig = getMerchantPreOnboardingServicesConfig([defaultPayFaq])
    const filteredServicesConfig = servicesConfig.map((section) =>
        section.filter((input) => {
            const services = getMerchantPreOnboardingSwiipeServices(input.inputName)
            if (
                services &&
                services.length > 0 &&
                services.filter((s) => isServiceAvailableForMerchantCountry(s, merchantCountryCode)).length === 0
            ) {
                return false
            }
            return true
        })
    )

    return (
        <div className="merchant-onboarding-services-form">
            {filteredServicesConfig.map((section, index) => {
                const fields = section
                    .filter((c) => !c.hide)
                    .map((s) => (!values?.[s.inputName] ? [s] : [s, ...(s.dependencies ?? [])]))
                    .flat()
                return (
                    <div className="merchant-onboarding-services-form__section" key={index}>
                        {fields.map((field) => {
                            return (
                                <FormGroupWithCheckbox
                                    key={field.inputName}
                                    innerRef={control.register()}
                                    name={getFieldSelector(field.inputName)}
                                >
                                    <StandardParagraph isSubTitle className="my-0 d-inline-block">
                                        {field.title}
                                    </StandardParagraph>
                                </FormGroupWithCheckbox>
                            )
                        })}
                        {index < filteredServicesConfig.length - 1 && <LayoutSeparator hide={fields.length === 0} />}
                    </div>
                )
            })}
        </div>
    )
}
